import { useState } from "react";

import {
  Button,
  Col,
  Collapse,
  ListGroup,
  Row,
  ToggleButton,
} from "react-bootstrap";

//import { Redirect } from "react-router-dom"
import Agenda from "../../../assets/svg/Agenda";
import ColoredMarker from "../../../common/components/ColoredMarker";
//import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
// import { ReactComponent as CheckBig } from '../../../assets/svg/checkBig.svg';
import Sign from "../../../assets/svg/sign";
import HasProcuModal from "./common/HasProcuModal";
import HasChangeModal from "./common/HasChangeModal";
import Chrono from "../../../assets/svg/Chrono";
import ValidateApointmentModal from "./common/ValidateApointmentModal";
import { PropsFromReduxSelectAppointment } from "../containers/SelectAppointmentContainer";

const SelectAppointment = (_props: PropsFromReduxSelectAppointment) => {
  const [step, setStep] = useState(0);

  const [data] = useState({
    id: 124,
    duration: 1,
    type: "entrant",
    property: {
      address: {
        city: "Marseille",
        country: "France",
        street: "255 Avenue du Prado",
        zip: "13006",
      },
      title: "Dupont - 255 avenue du prado lot n°1",
      type: "t2",
      uid: "UNIQUE_UID",

      is_furnished: true,
      area: 39,
      category: "Appartement",
      roomNumber: 2,
      floor: "ETG 3",
    },
    //"operator": "Charles",
    agency: {
      agencyName: "Star Agency",
      managerName: "John Doe",
      address: "467 boulevard Alphonse Daudet",
      additionalAddress: "",
      zip: "13004",
      city: "Marseille",
      agencySchedules: [
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
      ],
    },
    dateIn: new Date(),
    dateOut: new Date(),
    leaseSignHour: "11:00",
  });

  const [newDate, setNewDate] = useState(new Date());
  const [newTime, setNewTime] = useState(data.agency.agencySchedules[0]);
  const [showProcuModal, setShowProcuModal] = useState(false);
  const [hasProcu, setHasProcu] = useState(false);
  const [displayDays, setDisplayDays] = useState([false, false]); //two days
  const [displayHours, setDisplayHours] = useState(6);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [hasChange, setHasChange] = useState(false);
  const [showValidate, setShowValidate] = useState(false);

  const reserve = () => {
    //TODO link with the back-end and await a reply

    //if success:
    setStep(1);
  };

  const openDisplayDays = (index: number) => {
    const temp = [];
    for (let i = 0; i < displayDays.length; i++) temp.push(false);
    temp[index] = !displayDays[index];
    if (temp[index]) {
      const copiedDate = new Date(newDate.getTime());
      copiedDate.setHours(copiedDate.getHours() + 24 * (index + 1));
      setNewDate(copiedDate);
    }
    setDisplayDays(temp);
  };

  const moreDays = () => {
    const temp: boolean[] = [];
    const copy = [...displayDays];
    for (let i = 0; i < copy.length; i++) temp.push(false);
    setDisplayDays(copy.concat(temp));
  };

  const incrementDate = (index: number) => {
    const copiedDate = new Date(data.dateIn.getTime());
    copiedDate.setHours(copiedDate.getHours() + 24 * index);
    return copiedDate.toLocaleDateString("fr-FR", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
  };

  //todo check if token is valide, else redirect
  //return <Redirect to="/" />

  switch (step) {
    case 0:
      return (
        <div className="m-3 p-2 pt-0 mt-2">
          <div className="d-flex justify-content-center w-100">
            <ColoredMarker color="#11BFA4" className="px-2 w-100">
              L’agence <strong>{data.agency.agencyName}</strong> vous invite à
              prendre rendez-vous avec un de nos experts
              {(data.type === "entrant" ||
                data.type === "sortant" ||
                data.type === "entrant/sortant") && (
                <span> d’état des lieux.</span>
              )}
              {data.type === "diagnostic" && <span> en diagnostics.</span>}
            </ColoredMarker>
          </div>
          <div className="border-bottom mt-4 mb-2" />
          <div className="d-flex flex-row justify-content-start gap-2">
            <div className="lavender-background d-flex align-items-center justify-content-center mt-2 mb-2">
              <Agenda color="#641abf" w="28" />
            </div>
            <p className="short-agenda-modal mt-3 pt-2">Prenez rendez-vous</p>
          </div>
          <div className="mt-2 d-flex flex-row d-flex justify-content-between align-items-center text-center">
            <div>
              {data.type === "entrant" && (
                <ColoredMarker color="#11BFA4">
                  État des lieux d’entrée
                </ColoredMarker>
              )}
              {data.type === "diagnostic" && (
                <ColoredMarker color="#11BFA4">
                  Diagnostics immobiliers
                </ColoredMarker>
              )}
              {(data.type === "sortant" || data.type === "entrant/sortant") && (
                <ColoredMarker color="#ECB900">
                  État des lieux de sortie
                </ColoredMarker>
              )}
            </div>
            <div className="short-agenda-modal">Durée: {data.duration}h</div>
          </div>

          <div className="d-flex flex-column justify-content-start text-start mt-3 mb-3">
            <p className="short-agenda-modal mb-0">
              {data.property.address.street}, {data.property.address.zip}{" "}
              {data.property.address.city}
            </p>
            <div className="d-flex flex-row gap-2 flex-wrap">
              <ColoredMarker color="#641ABF">
                {data.property.is_furnished === true ? "Meublé " : "Non Meublé"}
              </ColoredMarker>
              <ColoredMarker color="#641ABF">
                {data.property.category}
              </ColoredMarker>
              <ColoredMarker color="#641ABF">
                {data.property.roomNumber}
              </ColoredMarker>
              <ColoredMarker color="#641ABF">
                {data.property.area + "m²"}
              </ColoredMarker>
              <ColoredMarker color="#641ABF">
                {data.property.floor}
              </ColoredMarker>
            </div>
          </div>
          <small
            className="text-muted"
            style={{ fontSize: "10px", lineHeight: "0px" }}
          >
            Sélectionnez votre créneau en fonction des disponibilités.
            <strong>
              Nous vous recommandons de réserver rapidement votre rendez-vous.
            </strong>
          </small>
          <div className="d-flex justify-content-start ms-2 align-items-center text-start">
            <Sign />
            <p className="text-appointment pt-3 ms-4">
              {data.type === "entrant" && <span>Signature du bail le </span>}
              {(data.type === "sortant" || data.type === "entrant/sortant") && (
                <span>Date de fin de bail </span>
              )}
              {data.type === "diagnostic" && (
                <span>Date d’intervention souhaitée par votre agent </span>
              )}
              :
              <strong>
                {data.dateIn.toLocaleDateString("fr-FR", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
              </strong>
              {data.type !== "sortant" && data.type !== "entrant/sortant" && (
                <span>
                  à <strong>{data.leaseSignHour}</strong>
                </span>
              )}
            </p>
          </div>
          {/*<div className="mt-2 d-flex justify-content-center">
                    <DatePicker
                        className="w-100 add-prop-input date-select"
                        dateFormat="dd/MM/yyyy" locale="fr"
                        selected={newDate}
                        onChange={(date) => setNewDate(date)}
                        formatWeekDay={nameOfDay => nameOfDay.toUpperCase().substr(0, 1)}
                        inline
                    />
                </div>*/}
          {hasChange === true && (
            <div className="d-flex justify-content-center w-100">
              <ColoredMarker color="#ECB900" className="pb-0 w-100">
                <p className="pt-2">
                  {data.type === "entrant/sortant" && (
                    <span>
                      Votre rendez-vous d’état des lieux de sortie se fera en
                      même temps que l’état des lieux d’entrée de l'occupant qui
                      va vous succéder.
                      <br />
                      <br />
                      <strong>
                        Vous ne pourrez donc pas fixer de rendez-vous avant sa
                        signature de bail.
                      </strong>
                    </span>
                  )}
                  {(data.type === "entrant" ||
                    data.type === "sortant" ||
                    data.type === "diagnostic") && (
                    <span>
                      Vous avez indiqué ne pas être disponible le
                      <strong>
                        {data.dateIn.toLocaleDateString("fr-FR", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "2-digit",
                        })}
                      </strong>
                      pour votre état des lieux. Consultez d’autres
                      disponibilités.
                    </span>
                  )}
                </p>
              </ColoredMarker>
            </div>
          )}
          {data.type === "entrant/sortant" && (
            <div className="d-flex justify-content-start ms-2 align-items-center text-center">
              <Sign />
              <p className="text-appointment pt-3 ms-4">
                <span>Signature du bail le </span>:
                <strong>
                  {data.dateIn.toLocaleDateString("fr-FR", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "2-digit",
                  })}
                </strong>
                à <strong>{data.leaseSignHour}</strong>
              </p>
            </div>
          )}

          {hasChange === false && (
            <div className="mt-2 bg-container pb-2">
              <p className="text-appointment text-center">
                {(data.type === "entrant" ||
                  data.type === "sortant" ||
                  data.type === "entrant/sortant") && (
                  <span>État des lieux le </span>
                )}
                {data.type === "diagnostic" && <span>Diagnostics le </span>}:
                <strong>
                  {data.dateIn.toLocaleDateString("fr-FR", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "2-digit",
                  })}
                </strong>
                à
                <strong>
                  {newTime.substring(0, 2)}:{newTime.substring(3, 5)}
                </strong>
              </p>
              <div className="border-bottom mt-2 mb-2" />
              <Row className="pt-2">
                {data.agency.agencySchedules.map((value, index) => {
                  if (index > displayHours - 1) return <div key={index}></div>;
                  return (
                    <Col key={index} xs={4} md={4}>
                      <ToggleButton
                        className="m-0 btn-appointment mx-2 mb-2"
                        checked={newTime === value}
                        type="radio"
                        value="preVisit"
                        onClick={() => setNewTime(value)}
                      >
                        {value}
                      </ToggleButton>
                    </Col>
                  );
                })}
              </Row>
              {displayHours < data.agency.agencySchedules.length && (
                <>
                  <div className="border-bottom mt-2 mb-2" />
                  <Button
                    variant="none"
                    className="mt-2 w-100 d-flex justify-content-center align-items-center text-center gap-2"
                    onClick={() =>
                      setDisplayHours(
                        Math.min(
                          data.agency.agencySchedules.length,
                          displayHours + 3,
                        ),
                      )
                    }
                  >
                    <p className="fw-bold m-0 p-0 App-link">VOIR PLUS</p>
                  </Button>
                </>
              )}
            </div>
          )}

          {hasChange === true && (
            <>
              {displayDays.map((value, index) => {
                return (
                  <div key={index}>
                    <Button
                      variant="light"
                      className="mt-2 w-100 d-flex justify-content-between bg-container-btn align-items-center text-center gap-2"
                      onClick={() => openDisplayDays(index)}
                    >
                      <p className="fw-bold m-0 p-0">
                        {incrementDate(index + 1)}
                      </p>
                      <i className="bi bi-chevron-down"></i>
                    </Button>
                    <Collapse in={value}>
                      <div className="mt-2 bg-container pb-2">
                        <p className="text-appointment text-center">
                          État des lieux le :{" "}
                          <strong>{incrementDate(index + 1)}</strong> à
                          <strong>
                            {newTime.substring(0, 2)}:{newTime.substring(3, 5)}
                          </strong>
                        </p>
                        <div className="border-bottom mt-2 mb-2" />
                        <Row className="pt-2">
                          {data.agency.agencySchedules.map((value, index) => {
                            if (index > displayHours - 1)
                              return <div key={index}></div>;
                            return (
                              <Col xs={4} md={4} key={index}>
                                <ToggleButton
                                  className="m-0 btn-appointment mx-2 mb-2"
                                  checked={newTime === value}
                                  type="radio"
                                  value="preVisit"
                                  onClick={() => setNewTime(value)}
                                >
                                  {value}
                                </ToggleButton>
                              </Col>
                            );
                          })}
                        </Row>
                        {displayHours < data.agency.agencySchedules.length && (
                          <>
                            <div className="border-bottom mt-2 mb-2" />
                            <Button
                              variant="none"
                              className="mt-2 w-100 d-flex justify-content-center align-items-center text-center gap-2"
                              onClick={() =>
                                setDisplayHours(
                                  Math.min(
                                    data.agency.agencySchedules.length,
                                    displayHours + 3,
                                  ),
                                )
                              }
                            >
                              <p className="fw-bold m-0 p-0 App-link">
                                VOIR PLUS
                              </p>
                            </Button>
                          </>
                        )}
                      </div>
                    </Collapse>
                  </div>
                );
              })}
              <Button
                variant="light"
                className="mt-2 w-100 d-flex justify-content-center bg-container-btn align-items-center text-center gap-2"
                onClick={() => moreDays()}
              >
                <p className="fw-bold m-0 p-0 App-link">
                  AFFICHER PLUS DE DISPONIBILITÉS
                </p>
              </Button>
            </>
          )}

          <Button
            onClick={() => setShowProcuModal(true)}
            variant="light"
            className="mt-2 w-100 d-flex justify-content-start bg-container-btn align-items-center text-center gap-2"
          >
            <i
              className="bi bi-question-circle-fill"
              style={{ color: "#641ABF" }}
            ></i>
            <p className="text-appointment m-0">
              Vous ne pourrez pas être sur place ?
            </p>
          </Button>
          {hasChange === false && (
            <Button
              onClick={() => setShowChangeModal(true)}
              variant="light"
              className="mt-2 w-100 d-flex justify-content-start bg-container-btn align-items-center text-center gap-2"
            >
              <i
                className="bi bi-question-circle-fill"
                style={{ color: "#641ABF" }}
              ></i>
              <p className="text-appointment m-0">
                Prendre rendez-vous plus tard ?
              </p>
            </Button>
          )}
          <div className="d-flex justify-content-center mt-4">
            <Button
              disabled={newTime === ""}
              variant="success"
              className="w-75"
              onClick={() => setShowValidate(true)}
            >
              Réserver
            </Button>
            <ValidateApointmentModal
              show={showValidate}
              setShow={setShowValidate}
              reserve={reserve}
              newDate={newDate}
              newTime={newTime}
              type={data.type}
              property={data.property}
              duration={data.duration}
            />
          </div>
          <HasProcuModal
            show={showProcuModal}
            setShow={setShowProcuModal}
            data={hasProcu}
            setData={setHasProcu}
          />
          <HasChangeModal
            show={showChangeModal}
            setShow={setShowChangeModal}
            data={hasChange}
            setData={setHasChange}
            date={data.dateIn.toDateString()}
          />
        </div>
      );
    case 1:
      return (
        <div className="m-3 mt-1 p-2">
          <div
            className="  d-flex flew-row justify-content-start gap-2 register-title text-center p-2 thankYouTitle align-items-center"
            style={{ backgroundColor: "#11BFA41A" }}
          >
            {/*<CheckBig />*/}
            <div className="d-flex flex-column text-start align-items-start justify-content-start pt-3">
              <p className="text-green fw-bolder mb-0">Merci !</p>
              <p className="order-small-subtitle fw-bold">
                Votre rendez-vous a bien été confirmé
              </p>
            </div>
          </div>
          <div className="border-bottom mt-3 mb-3" />
          <div
            className="rounded p-0 align-items-center text-center"
            style={{ backgroundColor: "white" }}
          >
            <div
              className="rounded-top p-2 d-flex justify-content-start gap-2 align-items-center text-center position-relative"
              style={{ backgroundColor: "#641abf", color: "white" }}
            >
              <div className="ms-2">
                <Agenda color="#FFFFFF" w="28" />
              </div>
              <div className="d-flex justify-content-between w-100">
                <p className="my-auto">
                  {newDate.toLocaleDateString("fr-FR", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "2-digit",
                  })}
                </p>
                <p className="my-auto">{newTime}</p>
              </div>
            </div>
            <div className="d-flex justify-content-between p-4 pb-0">
              <div className="d-flex flex-column justify-content-start text-start">
                {data.type === "entrant" && (
                  <p className="text-appointment fw-bold">
                    État des lieux d’entrée
                  </p>
                )}
                {(data.type === "sortant" ||
                  data.type === "entrant/sortant") && (
                  <p className="text-appointment fw-bold">
                    État des lieux de sortie
                  </p>
                )}
                {data.type === "diagnostic" && (
                  <p className="text-appointment fw-bold">
                    Diagnostics immobiliers
                  </p>
                )}
                <p className="text-appointment">
                  {data.property.address.street}, {data.property.address.zip}{" "}
                  {data.property.address.city}
                </p>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <Chrono />
                <p className="text-appointment fw-bold App-link">
                  {data.duration}h
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-center m-2 pb-3">
              <Button
                variant="success"
                className="w-100"
                onClick={() => reserve()}
              >
                Ajouter à mon agenda
              </Button>
            </div>
          </div>
          <ListGroup>
            <ListGroup.Item>
              <strong>Préparez le rendez-vous</strong>
            </ListGroup.Item>
            <ListGroup.Item>
              <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-start gap-2">
                  <i
                    className="bi bi-info-circle"
                    style={{ color: "#641ABF" }}
                  ></i>
                  <p className="m-0 p-0" style={{ color: "#641ABF" }}>
                    Consignes et informations
                  </p>
                </div>
                <i className="bi bi-chevron-right"></i>
              </div>
            </ListGroup.Item>
            <ListGroup.Item>
              <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-start gap-2">
                  <i
                    className="bi bi-file-earmark-arrow-up"
                    style={{ color: "#641ABF" }}
                  ></i>
                  <p className="m-0 p-0" style={{ color: "#641ABF" }}>
                    Envoyer des documents
                  </p>
                </div>
                <i className="bi bi-chevron-right"></i>
              </div>
            </ListGroup.Item>
          </ListGroup>
        </div>
      );
    default:
      return <></>;
  }
};

export default SelectAppointment;
